let index100 = -1
var pieTime100
import { loopShowTooltip } from '@/api/loop-tooltip.js'
import {
	todayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from "../../../times/moment";
export default {
	methods: {
		// 获取头部站点下拉选
		getOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				orgId: userInfos.orgId,
			}
			this.$http
				.getAction(this.$api.cqfindDeviceByOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						this.isorgSelectData = true
						if (datas && datas.length) {
							this.$set(this.queryParam, 'deviceCode', datas[0]['deviceCode'])

							setTimeout(() => {
								// 获取图片数据
								this.pageNum = 0
								this.imgTotal = 1
								this.getImgList()
								// 获取统计报表
								this.loadData()
								// 获取右侧饼图数据
								this.getPieData()
							}, 100)
						} else {
							this.orgSelect = []
							this.isorgSelectData = false
						}
					} else {
						this.orgSelect = []
						this.isorgSelectData = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.isorgSelectData = false
				})
		},
		// 图表切换
		chartTableSwitch() {
			this.isEchart = !this.isEchart
			if (this.isEchart) {
				this.$nextTick(() => {
					// this.lineChart()
					this.getPieData()
				})
			}
		},
		// 获取图片数据
		getImgList() {
			console.log(this.imgPageNum)
			// this.imgLoading = true
			this.imgPageNum += 1
			if (this.imgPageNum > this.imgTotal) {
				return
			}
			console.log(this.imgPageNum)
			this.nowJiazai = true
			let param = Object.assign({}, this.queryParam)
			param.pageNum = this.imgPageNum
			param.pageSize = this.imgPageSize
			this.imgIsNoMore = true
			this.$http
				.postAction(this.$api.cqfindDevicePictureByDeviceCode, param)
				.then((res) => {
					this.imgIsNoMore = false
					this.nowJiazai = false
					if (res.meta.success) {
						let result = res.data || []
						// 判断图片有数据
						if (result.records.length > 0) {
							this.isimgListData = true
							let datas = result.records || []
							if (this.imgPageNum == 1) {
								this.imgTotal = Math.ceil(Number(result.total) / Number(this.imgPageSize))
								this.imgListData = datas
							} else {
								this.imgListData = this.imgListData.concat(datas)
							}
							// if (result.pages < this.imgPageNum) {
							// 	this.imgIsNoMore = true
							// 	console.log('禁用了')
							// } else {
							// 	this.imgPageNum += 1
							// 	// this.getImgList()
							// }
						} else {
							if (this.imgPageNum == 1) {
								this.imgListData = []
								this.isimgListData = false
								this.imgPageNum = 0
								this.imgIsNoMore = true
							} else {
								this.imgIsNoMore = false
							}
						}

						// if (result.records.length > 0) {
						// 	this.isimgListData = true
						// 	this.imgIsNoMore = false
						// 	let datas = result.records || []
						// 	if (this.imgPageNum == 1) {
						// 		this.imgListData = datas
						// 	} else {
						// 		this.imgListData = this.imgListData.concat(datas)
						// 	}
						// 	if (result.pages < this.imgPageNum) {
						// 		this.imgIsNoMore = true
						// 		console.log('禁用了')
						// 	} else {
						// 		this.imgPageNum += 1
						// 		// this.getImgList()
						// 	}
						// } else {
						// 	if (this.imgPageNum == 1) {
						// 		this.imgListData = []
						// 		this.isimgListData = false
						// 		this.imgPageNum = 1
						// 	} else {
						// 		this.imgIsNoMore = true
						// 	}
						// }
					} else {
						if (this.imgPageNum == 1) {
							this.imgListData = []
							this.isimgListData = false
							this.imgPageNum = 0
							this.imgIsNoMore = true
						} else {
							this.imgIsNoMore = false
						}
					}
				})
				.finally(() => {
					setTimeout(() => {
						this.imgLoading = false
					}, 500)
				})
		},
		// 图片下拉
		imgload() {
			console.log('imgload')
			// if (this.loadIndex == 0) {
			// 	this.loadIndex++
			// } else {
			// 	if (!this.imgIsNoMore) {
			// 		this.imgPageNum += 1
			if (this.queryParam.deviceCode && this.queryParam.deviceCode != '') {
				this.getImgList()
			}

			// 	}
			// }
		},
		// 数据请求到以后的数据处理
		loadBack(res) {
			let datas = JSON.parse(JSON.stringify(res.data.content))

			// 虫子类型处理  ---- start
			let lenData = [] //类型数组
			datas.forEach((item, index) => {
				let tableList = {}
				item.list.forEach((key, ind) => {
					let lenIndex = lenData.findIndex((kk) => {
						return kk == key.insectName
					})
					if (lenIndex > -1) {
					} else {
						lenData.push(key.insectName)
					}
					// 处理虫子类型和数量，便于图表的显示
					tableList[key.insectName] = key.insectNumber || 0
				})
				item.tableList = tableList
				item.insectDate = item.list[0]['insectDate'] || '--'
			})
			this.tableCTypes = lenData
			// 虫子类型处理  ---- end
			// 表格数据赋值
			this.tableData = datas
		},
		// 查询按钮点击：重置覆盖
		searchClick_() {
			this.$refs['ruleform'].validate((valid) => {
				if (valid) {
					let miao = this.queryParam.startTime.split(" ")[1] || "00:00:00";
					let preMonthDay = new Date(
						GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
						" " +
						miao
					); //6个月之后的日期
					let startTimeCuo = new Date(this.queryParam.endTime).getTime();
					if (startTimeCuo >= preMonthDay.getTime()) {
						this.$message("选择时间跨度范围不允许超过6个月", "warning");
						return false;
					}
					this.imgPageNum = 0
					this.imgTotal = 1
					// 获取图片数据
					this.imgload()
					// 获取统计报表
					this.loadData(1)
					if (this.isEchart) {
						// 获取右侧饼图数据
						this.getPieData()
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		// TODO 获取切换后的图表数据
		getPieData() {
			this.$http
				.postAction(this.url.chart, this.queryParam)
				.then(
					(res) => {
						if (res.meta.success) {
							this.isEchart = true
							let datas = res.data || {}
							// 饼图数据处理
							if (datas.insectTotalNum) {
								let insectTotalNum = datas.insectTotalNum
								let pieData = []

								Object.keys(insectTotalNum).forEach((item) => {
									pieData.push({
										name: item,
										value: insectTotalNum[item],
									})
								})
								let lineXData = []
								let lineYData = []
								// 处理折线图数据
								Object.keys(datas.insectNum).forEach((item) => {
									lineXData.push(item)
									lineYData.push(datas.insectNum[item])
								})
								// 绘制饼图
								if (pieData.length) {
									this.isShowChart = true
									this.$nextTick(() => {
										setTimeout(() => {
											this.peiChart(pieData)
										}, 200)
									})
								} else {
									this.isShowChart = false
								}
								if (lineXData.length) {
									this.isShowChart = true
									this.$nextTick(() => {
										setTimeout(() => {
											this.lineChart(lineXData, lineYData)
										}, 200)
									})
								}
							}
						} else {
						}
					},
					(error) => {
						console.log('error')
						this.isShowChart = false
					}
				)
				.finally(() => { })
		},
		// 左侧折线图
		lineChart(xData, yData) {
			// let xData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
			// let yData = [54, 66, 87, 21, 44, 22, 44, 87, 21, 35]
			let maxY = Math.max(...yData)
			let symbolSize = 60
			let symbolFont = 12
			let tops = '18%'
			if (maxY.length <= 2) {
				symbolSize = 40
				symbolFont = 16
			} else if (maxY.length > 2 && maxY.length <= 3) {
				symbolSize = 50
				symbolFont = 14
			} else if (maxY.length > 3 && maxY.length < 4) {
				symbolSize = 60
				symbolFont = 12
				tops = '18%'
			} else {
				symbolSize = 65
				symbolFont = 12
				tops = '20%'
			}
			const _this = this
			let myChart = this.$echarts.init(this.$refs.cqlines)
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [14, 17],
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#3EB5B0',
							type: 'solid',
							width: 2,
						},
					},
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						infos += `<div style="text-align:left;">昆虫数量：<span style="color:#2DAEA9">${param[0].value}个</span></div><div style="margin-top:12px">${param[0].name}</div`
						return infos
					},
				},
				color: '#2DAEA9',
				grid: {
					left: '5%',
					bottom: '15%',
					top: tops,
					right: '8%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					name: '(个)',
					nameTextStyle: {
						color: '#6B6B6B',
						fontSize: 14,
						align: 'right',
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					minInterval: 1,
				},
				series: [
					{
						type: 'line',
						smooth: true,
						showSymbol: false,
						symbolSize: 10,
						itemStyle: {
							borderColor: '#2DAEA9',
							borderWidth: 8,
						},
						areaStyle: {
							color: 'rgba(45, 174, 169, 0.26)',
						},
						lineStyle: {
							width: 4,
						},
						markPoint: {
							symbolSize: symbolSize,
							label: {
								color: '#fff',
								fontSize: symbolFont,
							},
							data: [
								{
									type: 'max',
									name: '最大值',
									itemStyle: {
										color: '#FF648C',
									},
								},
								{
									type: 'min',
									name: '最小值',
									itemStyle: {
										color: '#3EA2EF',
									},
								},
							],
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值',
									lineStyle: {
										type: 'solid',
										color: '#FFA800',
									},
									label: {
										position: 'middle',
										formatter: '平均值:{c}',
										color: '#FFA800',
										distance: 10,
										fontSize: 16,
									},
									symbol: 'none',
								},
							],
						},
						data: yData,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// 右侧饼图绘制
		peiChart(datas) {
			let colors = ['#2DAEA9', '#91CC75', '#5C7BD9']
			let myChart = this.$echarts.init(this.$refs.cqPie)
			var data = datas

			let option = {
				title: {
					show: false,
				},
				tooltip: {
					show: false, // 不显示
					trigger: 'item',
					backgroundColor: 'rgb(53, 53, 53, 0.51)',
					borderWidth: 0,
					textStyle: {
						fontSize: 15,
						color: '#02FCFF',
					},
					axisPointer: {
						type: 'line',
					},
					transitionDuration: 0,
					extraCssText: 'z-index: 100',
				},
				// 图例
				legend: {
					show: true,
					selectedMode: false,
					type: 'scroll',
					orient: 'vertical',
					icon: 'rect',
					top: 'center',
					right: '0%',
					height: '75%',
					itemGap: 30,
					itemWidth: 26,
					itemHeight: 12,
					textStyle: {
						fontSize: 14,
						color: '#454545',
					},
					pageButtonItemGap: 10, // 按钮和页信息之间的间隔
					pageButtonGap: 20, // 控制块和图例项之间的间隔
					pageIconInactiveColor: '#E1E1E1', // 按钮未激活颜色
					pageIconColor: '#C1C1C1', // 按钮颜色
					pageIconSize: [10, 20], // 翻页按钮的大小 [宽, 高]
					pageTextStyle: {
						color: '#2DAEA9',
						fontSize: 14,
					},
				},
				series: [
					// 饼图
					{
						type: 'pie',
						legendHoverLink: true,
						radius: ['55%', '77%'], // 决定环的宽度
						center: ['40%', '50%'], // 中心点，决定图表显示的位置
						// 环中间的轮播文字
						label: {
							color: '#454545',
							fontSize: 18,
							show: false,
							formatter: function (value) {
								return '{x|' + value.name + '} \n\n {y|' + value.value + '}'
							},
							rich: {
								x: {
									color: '#454545',
									fontSize: 16,
								},
								y: {
									color: '#454545',
									fontSize: 20,
									fontWeight: 800,
								},
							},
							position: 'center',
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold',
							},
						},
						labelLine: {
							normal: {
								show: false,
							},
						},

						data: data,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
			// tools.loopShowTooltip(myChart, option, { loopSeries: true })
			// 方法一
			// this.pieActive(myChart, option)
			// myChart.on('mouseover', (e) => {
			// 	if (e.dataIndex != index100) {
			// 		clearInterval(pieTime100)
			// 		myChart.dispatchAction({
			// 			type: 'downplay',
			// 			seriesIndex: 0,
			// 			dataIndex: index100,
			// 		})
			// 		myChart.dispatchAction({
			// 			type: 'showTip',
			// 			seriesIndex: 0,
			// 			dataIndex: index100,
			// 		})
			// 	}
			// })
			// myChart.on('mouseout', (e) => {
			// 	this.pieActive(myChart, option)
			// })
			// 方法二
			this.pieActive(myChart, option)
			$('#cqPie').mouseenter(() => {
				clearInterval(pieTime100)
				myChart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: index100,
				})
			})
			$('#cqPie').mouseleave(() => {
				this.pieActive(myChart, option)
			})

			// 方法三
			// if (option && typeof option === 'object') {
			// 	myChart.setOption(option, true)
			// 	pieTime100 && pieTime100.clearLoop()
			// 	pieTime100 = 0
			// 	pieTime100 = loopShowTooltip(myChart, option, {
			// 		interval: 3000, // 轮播间隔时间
			// 		loopSeries: true, // 是否开启轮播循环
			// 		dataLength: option.series[0].data.length,
			// 	})
			// }
		},
		pieActive(myChart, option) {
			clearInterval(pieTime100)
			index100 = -1 //高亮所在下标
			let dataLength = option.series[0].data.length // 当前饼图有多少个扇形
			// 用定时器控制饼图高亮
			pieTime100 = setInterval(() => {
				// 清除之前的高亮
				myChart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: index100,
				})
				index100 = (index100 + 1) % dataLength
				// 当前下标高亮
				myChart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: index100,
				})
				if (index100 > dataLength) {
					index100 = 0
				}
			}, 2000)
		},
	},
}
